var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPass24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83105 13.4375L4.83496 12.8809L6.0166 11.3867L4.34668 11.0107L4.65918 10L6.30469 10.6494L6.13379 8.83789H7.24707L7.07617 10.6494L8.74121 10.0195L9.03906 11.0352L7.35938 11.3867C7.37565 11.4095 7.56934 11.652 7.94043 12.1143C8.31478 12.5765 8.51986 12.832 8.55566 12.8809C8.53613 12.8939 8.37174 12.9867 8.0625 13.1592C7.75651 13.3317 7.59212 13.4245 7.56934 13.4375L6.68066 11.8604L5.83105 13.4375ZM11.2217 13.4375L10.2256 12.8809L11.4072 11.3867L9.7373 11.0107L10.0498 10L11.6953 10.6494L11.5244 8.83789H12.6377L12.4668 10.6494L14.1318 10.0195L14.4297 11.0352L12.75 11.3867C12.7663 11.4095 12.96 11.652 13.3311 12.1143C13.7054 12.5765 13.9105 12.832 13.9463 12.8809C13.9268 12.8939 13.7624 12.9867 13.4531 13.1592C13.1471 13.3317 12.9827 13.4245 12.96 13.4375L12.0713 11.8604L11.2217 13.4375ZM16.6123 13.4375L15.6162 12.8809L16.7979 11.3867L15.1279 11.0107L15.4404 10L17.0859 10.6494L16.915 8.83789H18.0283L17.8574 10.6494L19.5225 10.0195L19.8203 11.0352L18.1406 11.3867C18.1569 11.4095 18.3506 11.652 18.7217 12.1143C19.096 12.5765 19.3011 12.832 19.3369 12.8809C19.3174 12.8939 19.153 12.9867 18.8438 13.1592C18.5378 13.3317 18.3734 13.4245 18.3506 13.4375L17.4619 11.8604L16.6123 13.4375Z",
    fill: "#11302D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#11302D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72729 18.5455H15.8182",
    stroke: "#11302D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass24);
export default __webpack_public_path__ + "static/media/pass-24.6cbb3d783be81abf8c93277797e5a120.svg";
export { ForwardRef as ReactComponent };